import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { Company } from '../../model/company';
import { CompanyService } from '../../service/data/company.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CompanyFortnoxConfigComponent } from '../company-fortnox-config/company-fortnox-config.component';
import { ActionWindowService } from '../../../core/service/action-window.service';

@Component({
    selector: 'app-fortnox-form',
    templateUrl: './fortnox.component.html',
    styleUrls: ['./fortnox.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FortnoxComponent implements OnInit, OnDestroy {
  constructor(
    private _dataService: CompanyService,
    activatedRoute: ActivatedRoute,
    messageService: MessageService,
    private _injector: Injector,
    private _actionService: ActionWindowService,
    navigation: NavigationService
  ) {}

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
      this.sub = null;
    }
  }

  companySelected(company: Company) {
    this.sub.add(this._actionService.open(CompanyFortnoxConfigComponent, this._injector, null, company).subscribe());
    return false;
  }

  private sub = new Subscription();
  companies: Company[];
  ngOnInit(): void {
    this.sub.add(
      this._dataService.getSelection('*', null, 1, 9999).subscribe(res => {
        this.companies = res.map(r => r.data);
      })
    );
  }
}
